__webpack_require__.p = "/ffx-monster-arena/";